import { DeliveryProvider, OFFER_KIND, PaymentMethod } from '../../../../../services/exports/Constants';

export default {
  customer_info: {
    dummy_order: 'Testitilaus',
    ordered_at: 'Tilattu:',
  },
  delivery_info: {
    info: 'Toimitustiedot:',
  },
  order_note: {
    label: 'Tilaushuomautus:',
  },
  schedule_info: {
    pickup: 'Nouto',
    delivery: 'Toimitus',
    on_site: 'Pöytätilaus',
    wish_time: 'Toivottu aika:',
    confirmed_time: 'Vahvistettu aika:',
    driver_arrival_time: 'Kuljettajan noutoaika:',
    external_delivery: 'Tilauksen toimittaa ulkopuolinen kuljettaja palvelusta {{carrier}}',
  },
  products: {
    item: 'Tuote:',
  },
  discount_breakdown: {
    label: 'Alennus',
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: 'Prosenttialennus kokonaissummasta käytetty',
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: 'Prosenttialennus tuotteista käytetty',
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: 'Summa-alennus tuotteista käytetty',
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: 'Summa-alennus kokonaissummasta käytetty',
    [OFFER_KIND.BOGO]: 'Bogo käytetty',
    [OFFER_KIND.BOGO_HALF_PRICE]: 'Bogo puoleen hintaan käytetty',
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Ilmainen tuote tuotteiden perusteella käytetty',
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Ilmainen tuote kokonaissumman perusteella käytetty',
    GiftCard: 'Lahjakortti käytetty',
    Reward: 'Kanta-asiakaspisteet käytetty',
    CashbackAccount: 'Kanta-asiakaspisteet käytetty',
    PromoCodeComponent: 'Promokoodi käytetty',
    Offer: 'Tarjous käytetty',
  },
  payment_breakdown: {
    price: 'Hinta:',
    subtotal: 'Välisumma',
    delivery_fee: 'Toimitusmaksu',
    tips: 'Tippi',
    processing_fee: 'Verkkopalvelumaksu',
    payment_method_upcharge_fee: {
      [PaymentMethod.Paypal]: 'PayPal-maksu',
    },
    tax: 'Verot',
    total: 'Yhteensä',
    paid_amount: 'Maksettu summa',
    order_not_paid: 'Tilausta ei ole vielä maksettu',
    order_paid_online: 'Jo maksettu verkossa',
    cash: 'Maksu paikan päällä',
    this_is_not_an_invoice: 'Tämä ei ole lasku',
  },
  delivery_qr_code: {
    scan: 'Skannaa ja toimita Google Mapsilla',
  },
  delivery_providers: {
    [DeliveryProvider.UberDrive]: 'Uber',
    [DeliveryProvider.FirstDelivery]: 'Uber',
    [DeliveryProvider.WoltDrive]: 'Wolt',
  },
};
